import {
  SubscriptionCustomerItemProps,
  SubscriptionItemProps,
} from '../../../../../store/subscription/types';
import { SubscriptionSolicitationSuccessDetailsProps } from '../SubscriptionSolicitationSuccessDetails';

export const getSuccessInfoItems = (
  customer: SubscriptionCustomerItemProps,
  subscription: SubscriptionItemProps,
  quantity: number
): SubscriptionSolicitationSuccessDetailsProps['infoItems'] => {
  return [
    { label: 'Subscrição', value: subscription.productDisplay },
    { label: 'Cliente', value: customer.customerNameNormalized },
    { label: 'Quantidade', value: quantity.toString() },
    { label: 'Protocolo', value: '--' },
  ];
};
